module.exports = __webpack_public_path__ + "img/special4.770f022c.png";